export const getListItems = (list) => {
    if (Array.isArray(list))
        return list;
    if (list && Array.isArray(list.data))
        return list.data;
    return [];
};
export const getListPagination = (list) => {
    if (!Array.isArray(list) && list?.meta) {
        return {
            current_page: list.meta.current_page || 1,
            last_page: list.meta.last_page || 1
        };
    }
    return { current_page: 1, last_page: 1 };
};
export const addItemToList = (list, item) => {
    if (Array.isArray(list)) {
        return [...list, item];
    }
    return { ...list, data: [...list.data, item] };
};
export const replaceItemInList = (list, updated) => {
    if (Array.isArray(list)) {
        return list.map((item) => (item.id === updated.id ? updated : item));
    }
    return { ...list, data: list.data.map((item) => (item.id === updated.id ? updated : item)) };
};
export const findItemInList = (list, id) => getListItems(list).find((item) => item.id === id);
export const removeItemFromList = (list, id) => {
    if (Array.isArray(list)) {
        return list.filter((item) => item.id !== id);
    }
    return { ...list, data: list.data.filter((item) => item.id !== id) };
};
